import styled from 'styled-components';
import cores from '../../styles/cores';

export const ModalContainerEditCommission = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px;

  .title {
    font-size: 24px;
    font-weight: 600;
  }


  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    margin-top: 16px;

    strong {
      font-weight: 600;
    }

    .status-bloqueado {
      strong {
        color: ${cores.red};
      }
    }

    .status-liberado {
      strong {
        color: #4CAF50;
      }
    }

    .text-confirmacao {
      font-size: 16px;
    }
  }
`;


export const BotaoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
  width: 100%;
`;
